export default __webpack_public_path__ + "static/media/bg.5881ce6d.webp";